<template>
  <div>
    <div class="mb-3 d-flex">
      <gmap-autocomplete
          id="autocomplete" class="search-location" :options="autocompleteOptions" @place_changed="initMarker">
      </gmap-autocomplete>
      <div class="ml-2">
        <b-tooltip target="reset-btn" :title="$t('Reset')"/>
        <b-button variant="primary" id="reset-btn" @click="onSearchReset">
          <font-awesome-icon icon="undo"/>
        </b-button>
      </div>
    </div>
    <gmap-map ref="map" :zoom="zoom" :center="coordinates" class="google-maps" @click="onCoordinateChange">
      <gmap-marker :position="coordinates"/>
    </gmap-map>
  </div>
</template>

<script>
  export default {
    name: "GoogleMap",
    props: {
      coordinates: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        zoom: 14,
        autocompleteOptions: {
          fields: ['geometry', 'opening_hours', 'business_status']
        },
      }
    },
    methods: {
      onCoordinateChange(event) {
        const params = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        }
        this.$emit('on-coordinate-change', params);
      },
      initMarker(event) {
        const params = {
          latLng: event.geometry.location
        }
        this.onCoordinateChange(params);
      },
      onSearchReset() {
        const searchInput = document.getElementById('autocomplete');

        if (searchInput) {
          searchInput.value = '';
        }
      },
      initCurrentLocation(event) {
        const controlDiv = document.createElement('div');
        const firstChild = document.createElement('button');

        firstChild.className = 'current-location-button';
        firstChild.title = this.$i18n.t('Your Location');

        firstChild.innerHTML = `<i class="fas fa-map-marker-alt"/>`;

        controlDiv.appendChild(firstChild);

        firstChild.addEventListener('click', (ev) => {
          ev.preventDefault();

          navigator.geolocation.getCurrentPosition(position => {
            const params = {
              latLng: new window.google.maps.LatLng(
                  parseFloat(position.coords.latitude),
                  parseFloat(position.coords.longitude)
              )
            };
            this.$refs.map.$mapObject.setCenter(params.latLng);
            this.onCoordinateChange(params);
          })
        })
        controlDiv.index = 1;

        this.$refs.map.$mapObject.controls[event.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.map.$gmapApiPromiseLazy().then(this.initCurrentLocation);
      });
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../../scss/index";

  .google-maps {
    width: 100%;
    height: 600px;
  }

  /deep/ .search-location {
    width: 25%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.85rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    &:focus {
      border-color: $ams-table-head-cell-focus-outline;
    }
  }

  /deep/ .current-location-button {
    background-color: #fff;
    border: none;
    outline: none;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 0;

    :hover {
      color: #333333;
    }

    > svg {
      font-size: 20px;
      color: #626E80;
    }
  }
</style>

<style lang="scss">
  .pac-container {
    z-index: 99999;

    .pac-item {
      padding: 6px;
    }
  }
</style>